import * as React from "react";

export const IconHamburger = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
    <path d="M0 4H32" stroke="currentColor" strokeWidth="3" />
    <path d="M0 16H32" stroke="currentColor" strokeWidth="3" />
    <path d="M0 28H32" stroke="currentColor" strokeWidth="3" />
  </svg>
);
